import { render, staticRenderFns } from "./AnswerHeart.vue?vue&type=template&id=2529a6cf&"
import script from "./AnswerHeart.vue?vue&type=script&lang=js&"
export * from "./AnswerHeart.vue?vue&type=script&lang=js&"
import style0 from "./AnswerHeart.vue?vue&type=style&index=0&id=2529a6cf&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports